import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
  TREQUEST_AuditLogsDetails,
  TREQUEST_AuditSummary,
  TREQUEST_AuditSummaryFiltersData,
  TREQUEST_getAqlLevel,
  TREQUEST_MeasurementPointsByBctx,
  TRESPONSE_AuditLogsDetails,
  TRESPONSE_getAQLLEVEL,
  TRESPONSE_AuditSummary,
  TRESPONSE_AuditSummaryFilters,
  TMeasurement_issue,
  TGetAQLLevelsBuyerDepartmentRequestV2,
} from '@monorepo/types';
import { AqlAppEnvService } from '@monorepo/services';

@Injectable({
  providedIn: 'root',
})
export class AqlAppDataService {
  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
    }),
  };
  constructor(public http: HttpClient, public AqlAppEnvService: AqlAppEnvService) {}

  getMeasurementPointsBasedOnSize(request: TREQUEST_MeasurementPointsByBctx) {
    const url = this.AqlAppEnvService.getEnvVar('GET_MEASUREMENTS_LIST_BASED_ON_SIZE');

    return this.http.post<TMeasurement_issue[]>(url, request, this.httpOptions);
    // return of(measurementPoints);
  }

  getAqlLevel(payload: TREQUEST_getAqlLevel) {
    const buyerAndDepartment: TGetAQLLevelsBuyerDepartmentRequestV2 = {
      buyer: payload.buyer,
      department: payload.department,
    };
    const url = this.AqlAppEnvService.getEnvVar('GET_AQL_LEVELS_BY_BUYER_DEPARTMENT');
    return this.http.post<TRESPONSE_getAQLLEVEL>(`${url}/${payload.factoryId}`, buyerAndDepartment, this.httpOptions);
  }

  getAqlListingPagesLogs(request: TREQUEST_AuditLogsDetails) {
    const url = this.AqlAppEnvService.getEnvVar('GET_AQL_LISTING_PAGES_LOGS');
    return this.http.post<TRESPONSE_AuditLogsDetails>(url, request, this.httpOptions);
  }

  getAqlAuditSummary(request: TREQUEST_AuditSummary | TREQUEST_AuditSummaryFiltersData) {
    const url = this.AqlAppEnvService.getEnvVar('GET_AQL_AUDIT_SUMMARY');
    return this.http.post<TRESPONSE_AuditSummary | TRESPONSE_AuditSummaryFilters>(url, request, this.httpOptions);
  }
}
